import { createContext, useContext, useState, useEffect } from 'react';
import api, { endpoints } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [authConfig, setAuthConfig] = useState({ mode: 'keycloak', sso: true, loginUrl: '/api/auth/login' });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        async function bootstrapAuth() {
            const savedToken = localStorage.getItem('token');
            if (savedToken) {
                api.defaults.headers.common['Authorization'] = `Bearer ${savedToken}`;
            }
            try {
                const cfgResp = await endpoints.auth.config();
                if (active && cfgResp?.data) {
                    setAuthConfig(cfgResp.data);
                }
            } catch (_) {
                // fallback a keycloak por defecto
            }
            try {
                const meResp = await endpoints.auth.me();
                if (active && meResp?.data) {
                    setUser(meResp.data);
                }
            } catch (_) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                delete api.defaults.headers.common['Authorization'];
                if (active) setUser(null);
            } finally {
                if (active) setLoading(false);
            }
        }
        bootstrapAuth();
        return () => { active = false; };
    }, []);

    const loginSso = () => {
        window.location.href = authConfig.loginUrl || '/api/auth/login';
    };

    const login = async (username) => {
        if (authConfig.mode !== 'mock') {
            loginSso();
            return null;
        }
        const resp = await endpoints.auth.mockLogin(username);
        const { user: userData, token } = resp.data;
        if (token) {
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(userData));
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        setUser(userData);
        return userData;
    };

    const logout = async () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        delete api.defaults.headers.common['Authorization'];
        setUser(null);
        try {
            const resp = await endpoints.auth.logout();
            if (resp.data?.logoutUrl && resp.data.logoutUrl.startsWith('http')) {
                window.location.href = resp.data.logoutUrl;
                return;
            }
        } catch (_) {
            // noop
        }
    };

    return (
        <AuthContext.Provider value={{ user, authConfig, login, loginSso, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
